export default __webpack_public_path__ + "static/media/il_support_left.b5a4df6b.svg";